import React, { Component } from "react";
import { AppContext } from "../common/AppContext";
import { LoadingModel } from "../common/models/LoadingModel";
import { LoadingBar } from "./LoadingBar";

/**
 * Base props interface for dialogs
 */
export interface AbstractDialogProps {
  open?: boolean;
  [key: string]: unknown;
}

/**
 * Base state interface for dialogs
 */
export interface AbstractDialogState {
  open?: boolean;
  loadingModel?: LoadingModel;
  [key: string]: unknown;
}

export class AbstractDialog<
  P extends AbstractDialogProps = AbstractDialogProps,
  S extends AbstractDialogState = AbstractDialogState
> extends Component<P, S> {
  static contextType = AppContext;
  declare context: React.ContextType<typeof AppContext>;

  loadingModel: LoadingModel;
  loadingBarRef: React.RefObject<LoadingBar | null>;
  loadingBar: React.RefObject<LoadingBar> | null = null;

  constructor(props: P) {
    super(props);

    this.state = {
      open: props.open ?? false,
      loadingModel: new LoadingModel()
    } as S;

    this.loadingModel = new LoadingModel();
    this.loadingBarRef = React.createRef();
  }

  setLoading(event: string | null, loading: boolean): void {
    this.loadingModel.setLoading(event, loading);
    if (this.loadingBar?.current) {
      this.loadingBar.current.setLoading(this.loadingModel.isLoading);
    }
  }

  renderLoadingBar(): React.ReactNode {
    return <LoadingBar ref={this.loadingBarRef} />;
  }

  open(open?: boolean): void {
    this.setState({ open: open !== undefined ? open : true } as unknown as S);
  }

  close(): void {
    this.setState({ open: false } as unknown as S);
  }
}
